export default __webpack_public_path__ + "static/media/illustration-your-users.c07ebfaa.svg";